// removed by extract-text-webpack-plugin
module.exports = {"content":"_2a6eU6d4WWUgxhAiT2Jqpu","logo":"VBQAwbOWifNWDuaP3WRNc"};


//////////////////
// WEBPACK FOOTER
// ./src/views/live/css/create.module.css
// module id = 340
// module chunks = 0